export class FileDto {
    fileName : string = "";
    filePath : string = "";
    content : string = "";
}